﻿//may be mixing up state and command base class
export default class State {
    constructor(context) {
        this.context = context;
    }
    setup() {

    }
    action(command, value, player) {
        switch (command) {
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        return [];
    }

    unknownCommand(command, value, player) {
        this.context.unknownCommand( command, null, player);
    }
}